import { render, staticRenderFns } from "./rongyu.vue?vue&type=template&id=0da8cf92&scoped=true"
import script from "./rongyu.vue?vue&type=script&lang=js"
export * from "./rongyu.vue?vue&type=script&lang=js"
import style0 from "./rongyu.vue?vue&type=style&index=0&id=0da8cf92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da8cf92",
  null
  
)

export default component.exports